module.exports = "https://cdn2-fs.clearscore.com/flux/images/d7126f256ecbec588d537de5201cfe5f.jpg";